import { sizes } from '@constants/theme/sizes.config';
import styled from '@emotion/styled';
import { UIFlexBox } from '../ui/layout';

export const SadaKHeading = styled(UIFlexBox)`
  height: ${({ sm }) => (sm ? sizes.md : sizes.lg)};
  justify-content: space-between;
  align-items: center;
`;
